export class Helpers {
    pathToPoints(element, polygonSample = 1000) {

        if (typeof element.node().getTotalLength != 'function') {
            return [];
        }

        let path = element._groups[0][0];
        let length = element.node().getTotalLength();

        let points = [];
        for (var i = 1, l = polygonSample; i < l; i++) {
            var point = path.getPointAtLength(i / l * length);
            points.push([point.x, point.y]);
        }

        return points;
    }

    getLength(element) {
        if (typeof element.node().getTotalLength != 'function') {
            return 9999666;
        }
        
        return element.node().getTotalLength();
    }
    
    checkIfInsdePolygon(point, vs) {
        // vs - polygon points
        // ray-casting algorithm based on
        // http://www.ecse.rpi.edu/Homepages/wrf/Research/Short_Notes/pnpoly.html

        var x = point[0], y = point[1];

        var inside = false;
        for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
            var xi = vs[i][0], yi = vs[i][1];
            var xj = vs[j][0], yj = vs[j][1];

            var intersect = ((yi > y) != (yj > y))
                    && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
            if (intersect)
                inside = !inside;
        }

        return inside;
    }

    closestPoint(pathNode, point) {
        var pathLength = pathNode.getTotalLength(),
                precision = 8,
                best,
                bestLength,
                bestDistance = Infinity;
        // linear scan for coarse approximation
        for (var scan, scanLength = 0, scanDistance; scanLength <= pathLength; scanLength += precision) {
            if ((scanDistance = distance2(scan = pathNode.getPointAtLength(scanLength))) < bestDistance) {
                best = scan, bestLength = scanLength, bestDistance = scanDistance;
            }
        }
        // binary search for precise estimate
        precision /= 2;
        while (precision > 0.5) {
            var before,
                    after,
                    beforeLength,
                    afterLength,
                    beforeDistance,
                    afterDistance;
            if ((beforeLength = bestLength - precision) >= 0 && (beforeDistance = distance2(before = pathNode.getPointAtLength(beforeLength))) < bestDistance) {
                best = before, bestLength = beforeLength, bestDistance = beforeDistance;
            } else if ((afterLength = bestLength + precision) <= pathLength && (afterDistance = distance2(after = pathNode.getPointAtLength(afterLength))) < bestDistance) {
                best = after, bestLength = afterLength, bestDistance = afterDistance;
            } else {
                precision /= 2;
            }
        }
        best = [best.x, best.y];
        best.distance = Math.sqrt(bestDistance);
        return best;
        function distance2(p) {
            var dx = p.x - point[0],
                    dy = p.y - point[1];
            return dx * dx + dy * dy;
        }
    }
    
    round(val){
        return Math.round(val * 100) / 100;
    }
    
    getAllElementsWithAttribute(attribute) {
        var matchingElements = [];
        var allElements = document.getElementsByTagName('*');
        for (var i = 0, n = allElements.length; i < n; i++)
        {
            if (allElements[i].getAttribute(attribute) !== null)
            {
                // Element exists with attribute. Add to array.
                matchingElements.push(allElements[i]);
            }
        }
        return matchingElements;
    }
    
    
}
